import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import css from 'styled-jsx/css';
import ErrorIllustration from 'static/assets/images/common/error.png';
import Cookies from 'js-cookie';

const { className, styles } = css.resolve`
  .message {
    height: calc(100vh - 50px);
  }
`;

const en = {
  helpfulLinksTitle: 'Here are some helpful links:',
  projects: 'Projects',
  appearance: 'Appearance',
  reporting: 'Reporting',
  accessDeniedErrorMessage: '403 Error',
  accessDeniedErrorMessageTitle: 'Access denied',
  accessDeniedErrorMessageSubTitle:
    'You do not have permission to access the requested page.',
  missingUrlErrorMessage: '404 Error',
  missingUrlErrorMessageTitle: "We couldn't find this page.",
  missingUrlErrorMessageSubTitle:
    "You may have entered an old URL or clicked on a URL from a previous version of this application. The page you're looking for may have been removed or relocated.",
};

const fr = {
  helpfulLinksTitle: 'Voici quelques liens utiles:',
  projects: 'Projets',
  appearance: 'Apparence',
  reporting: 'Rapports',
  accessDeniedErrorMessage: '403 Erreur',
  accessDeniedErrorMessageTitle: 'Accès refusé',
  accessDeniedErrorMessageSubTitle:
    'Vous n’avez pas la permission d’accéder à la page demandée.',
  missingUrlErrorMessage: '404 Erreur',
  missingUrlErrorMessageTitle:
    'Oups! Désolé que vous semblez avoir entré une URL erronée',
  missingUrlErrorMessageSubTitle:
    "Vous avez peut-être entré une ancienne URL ou cliqué sur une URL à partir d'une version précédente de cette application. S'il vous plaît utiliser la navigation sur la gauche pour trouver la page correcte.",
};

const translations = {
  en: en,
  'en-US': en,
  'fr-CA': fr,
};

const Error = ({ statusCode }) => {
  const [language, setLanguage] = React.useState('en');

  useEffect(() => {
    // access cookie as key value using cookie js
    const lang = Cookies.get('current_language') || 'en';
    setLanguage(lang);
  }, []);

  // Always fallback to English if language is not present
  const t = translations[language] || translations['en'];

  const HelpfulLinks = () => {
    return (
      <div className="ehq-mt-10">
        <p>{t['helpfulLinksTitle']}</p>
        <div className="ehq-flex ehq-justify-between ehq-w-64 ehq-my-0 ehq-mx-auto">
          <a href="/admin/projects">{t['projects']}</a>
          <a href="/admin/sites/editors/home-page">{t['appearance']}</a>
          <a href="/admin/reporting/summary">{t['reporting']}</a>
        </div>
      </div>
    );
  };

  const errorNode = ({ errCode, title, subTitle }) => {
    return (
      <div
        className={`${className} message ehq-flex ehq-items-center ehq-justify-center ehq-m-6 ehq-bg-white ehq-rounded ehq-flex-col`}
      >
        <img src={ErrorIllustration} alt={title} height="300" />
        <div className="ehq-mt-6 ehq-max-w-md ehq-text-center">
          <p
            className={`${className} ehq-text-2xl ehq-font-semibold ehq-leading-loose ehq-text-black`}
          >
            {errCode}
          </p>
          <p className="ehq-text-base ehq-font-semibold">{title}</p>
          <p className="ehq-text-sm">{subTitle}</p>
          <HelpfulLinks />
        </div>
        {styles}
      </div>
    );
  };

  return statusCode === '403'
    ? errorNode({
        errCode: t['accessDeniedErrorMessage'],
        title: t['accessDeniedErrorMessageTitle'],
        subTitle: t['accessDeniedErrorMessageSubTitle'],
      })
    : errorNode({
        errCode: t['missingUrlErrorMessage'],
        title: t['missingUrlErrorMessageTitle'],
        subTitle: t['missingUrlErrorMessageSubTitle'],
      });
};

Error.propTypes = {
  statusCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Error;
